import React from "react";
import Navbar from "../layout/Navbar";
import { HERO_CONTENT } from "../../constants/copy";
import Reveal from "../common/Reveal";
import ukuleleImage from "../../assets/images/ukulele.png";

const IntroHero: React.FC = () => {
  return (
    <section
      id="home"
      className="relative overflow-x-hidden bg-gradient-to-br from-primary via-accentGold/5 to-accentNavy/10 text-accentNavy"
    >
      {/* Gradient background layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-accentNavy/20 via-transparent to-accentGold/15" />
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-accentGold/10 to-accentNavy/25" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-accentGold/20 via-transparent to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-transparent via-transparent to-accentNavy/20" />

      {/* Decorative gradient blur effects */}
      <div className="absolute inset-x-0 top-40 hidden h-[540px] -skew-y-3 bg-gradient-to-r from-accentGold/20 via-transparent to-accentNavy/20 blur-3xl lg:block" />
      <div className="absolute -right-32 top-1/2 h-96 w-96 rounded-full bg-accentGold/30 blur-3xl" />
      <div className="absolute -left-32 bottom-1/4 h-96 w-96 rounded-full bg-accentNavy/20 blur-3xl" />

      <Navbar />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col items-center justify-center px-6 pb-20 pt-36 text-center lg:px-10 lg:pt-40">
        <div className="flex w-full flex-col items-center justify-center gap-8 lg:flex-row lg:items-center lg:justify-center lg:gap-12">
          {/* Text Content */}
          <div className="flex flex-col items-center justify-center lg:max-w-2xl xl:max-w-3xl">
            <Reveal>
              <h1 className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl xl:text-6xl 2xl:text-7xl">
                {HERO_CONTENT.headline}
              </h1>
            </Reveal>
            <Reveal delay={120}>
              <p className="mt-6 text-lg text-accentNavy/70 lg:text-xl xl:text-xl 2xl:text-2xl">
                {HERO_CONTENT.description}
              </p>
            </Reveal>

            <Reveal delay={220}>
              <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                <a
                  href={HERO_CONTENT.primaryCta.href}
                  className="inline-flex items-center justify-center rounded-full bg-accentNavy px-8 py-3 text-sm font-semibold uppercase tracking-wide text-primary shadow-brand transition-transform duration-200 hover:-translate-y-0.5 lg:px-10 lg:py-4 lg:text-base"
                >
                  {HERO_CONTENT.primaryCta.label}
                </a>
                <a
                  href={HERO_CONTENT.secondaryCta.href}
                  className="inline-flex items-center justify-center rounded-full border border-accentNavy/20 px-8 py-3 text-sm font-semibold uppercase tracking-wide text-accentNavy transition-colors duration-200 hover:border-accentGold hover:text-accentGold lg:px-10 lg:py-4 lg:text-base"
                >
                  {HERO_CONTENT.secondaryCta.label}
                </a>
              </div>

              {/* App store nudge — sits naturally below the CTAs */}
              <div className="mt-5 flex items-center justify-center gap-3">
                <span className="h-px w-8 bg-accentNavy/20" />
                <span className="text-xs text-accentNavy/50">Get access to all courses on our mobile app</span>
                <span className="h-px w-8 bg-accentNavy/20" />
              </div>
              <div className="mt-3 flex justify-center">
                <a
                  href="https://play.google.com/store/apps/details?id=co.martin.swjtr"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Get it on Google Play"
                  className="transition-all duration-200 hover:-translate-y-0.5 hover:opacity-90"
                >
                  <img
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    alt="Get it on Google Play"
                    className="h-14 w-auto"
                  />
                </a>
              </div>
            </Reveal>
          </div>

          {/* Image */}
          <Reveal delay={180} className="flex items-center justify-center lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
            {/* <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl"> */}
            <img
              src={ukuleleImage}
              alt="Ukulele"
              className="w-full h-auto max-h-[400px] sm:max-h-[500px] md:max-h-[500px] lg:max-h-[650px] xl:max-h-[700px] 2xl:max-h-[750px] object-contain drop-shadow-2xl transition-all duration-500 ease-out hover:scale-110 hover:rotate-3 hover:drop-shadow-[0_25px_50px_-12px_rgba(0,0,0,0.8)]"
            />
            {/* </div> */}
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default IntroHero;


